import * as THREE from "three";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader.js";
import { MTLLoader } from "three/examples/jsm/loaders/MTLLoader.js";

export const proceeCallbacks = [];

const onProgress = function(xhr) {
	if (xhr.lengthComputable) {
		const percentComplete = (xhr.loaded / xhr.total) * 100;
		for (let callback of proceeCallbacks) {
			callback(percentComplete);
		}
		console.log(Math.round(percentComplete, 2) + "% downloaded");
	}
};
const onError = function() {};

const manager = new THREE.LoadingManager();

export const modelMap = new Map();

export function preLoad() {
	if (modelMap.has("2")) return modelMap.get("2");
	return new Promise(res => {
		new MTLLoader(manager)
			.setPath("/static/models/")
			.load("3.mtl", function(materials) {
				materials.preload();
				console.log(materials);
				new OBJLoader(manager)
					.setMaterials(materials)
					.setPath("/static/models/")
					.load(
						"3.obj",
						function(object) {
							for (let callback of proceeCallbacks) {
								callback(-1);
							}
							modelMap.set("2", object);
							res(object);
						},
						onProgress,
						onError
					);
			});
	});
}
